<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="M21 21L16.5 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>
